// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorReservations = (client) => ({
    /**
     * `POST /vendor/reservations`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCreateReservation
     * @source packages/modules/b2c-core/src/api/vendor/reservations/route.ts
     */
    create: (body, query, headers) => client.fetch("/vendor/reservations", { method: "POST", body, query, headers }),
    /**
     * `DELETE /vendor/reservations/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDeleteReservationById
     * @source packages/modules/b2c-core/src/api/vendor/reservations/[id]/route.ts
     */
    delete: (id, body, query, headers) => client.fetch(buildPath("/vendor/reservations/:id", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /vendor/reservations`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListReservations
     * @source packages/modules/b2c-core/src/api/vendor/reservations/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/reservations", { method: "GET", query, headers }),
    /**
     * `GET /vendor/reservations/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetReservationById
     * @source packages/modules/b2c-core/src/api/vendor/reservations/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/vendor/reservations/:id", [id]), { method: "GET", query, headers }),
    /**
     * `POST /vendor/reservations/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorUpdateReservationById
     * @source packages/modules/b2c-core/src/api/vendor/reservations/[id]/route.ts
     */
    update: (id, body, query, headers) => client.fetch(buildPath("/vendor/reservations/:id", [id]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=reservations.js.map